<template>
  <div>
    <div>
      <b-modal
        id="modal-qr"
        :title="qrModalTitle"
        centered
        size="sm"
        footer-class="justify-content-center"
      >
        <qrcode-vue
          :value="qrValue"
          :size="200"
          level="H"
          class="text-center"
        ></qrcode-vue>

        <template #modal-footer>
          <b-button variant="success" class="btn-icon" @click="saveQr()">
            <feather-icon icon="DownloadIcon" />
            <span class="align-middle ml-50">{{ $t("Download") }}</span>
          </b-button>
          <b-button variant="primary" class="btn-icon" @click="copyQr()">
            <feather-icon icon="CopyIcon" />
            <span class="align-middle ml-50">{{ $t("Copy") }}</span>
          </b-button>
        </template>
      </b-modal>

      <b-modal
        id="modal-out"
        :title="$t('Visitor check out')"
        centered
        size="sm"
      >
        <b-form-group
          :label="$t('Checkout Time')"
          :invalid-feedback="$t('Visiting Time is required.')"
          ref="checkout_time"
        >
          <flat-pickr
            v-model="outObj.checkoutTime"
            :config="config3"
            class="form-control"
            :placeholder="$t('Select time')"
          />
        </b-form-group>

        <template #modal-footer>
          <b-button
            variant="success"
            class="btn-icon"
            :disabled="updating"
            @click="updateOut()"
          >
            <b-spinner v-if="updating" small type="grow" />
            <span class="align-middle ml-50">{{ $t("Update") }}</span>
          </b-button>
        </template>
      </b-modal>

      <b-modal
        id="modal-login"
        hide-footer
        centered
        no-close-on-backdrop
        :title="$t('Filters')"
      >
        <b-form>
          <b-form-group
            :label="$t('Class')"
            :invalid-feedback="$t('Class is required')"
            ref="fil_cls"
          >
            <v-select
              multiple
              :closeOnSelect="false"
              v-model="filter.clsIDs"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="filterClasses"
              :clearable="false"
              label="name"
              :reduce="(val) => val.id"
              input-id="id"
              ref="fil_cls"
              :placeholder="$t('Select class')"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Tag')"
            :invalid-feedback="$t('Tag is required.')"
            ref="fil_tag"
          >
            <v-select
              multiple
              :closeOnSelect="false"
              v-model="filter.tags"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="filterTags"
              :clearable="false"
              ref="fil_tag"
              :placeholder="$t('Select tag')"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Inquiry Date')"
            :invalid-feedback="$t('Date is required')"
            ref="inq_date"
          >
            <flat-pickr
              v-model="filterDate"
              :config="config2"
              class="form-control"
              :placeholder="$t('Select Date')"
              @on-change="setDate"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Follow up Date')"
            :invalid-feedback="$t('Date is required')"
            ref="f_date"
          >
            <flat-pickr
              v-model="filterFollowDate"
              :config="config2"
              class="form-control"
              :placeholder="$t('Select Date')"
              @on-change="setFDate"
            />
          </b-form-group>
        </b-form>
        <b-row class="mt-2">
          <b-col style="display: flex; justify-content: end">
            <b-button
              @click="LoadFilter()"
              style="padding: 12px 16px"
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              :disabled="dataLoading"
            >
              <span class="align-middle">{{ $t("Show data") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-card>
        <b-row class="mt-0 align-items-baseline">
          <b-col
            xl="2"
            lg="2"
            md="6"
            sm="6"
            cols="12"
            class="mb-1 mb-lg-0"
            v-if="rights.add"
          >
            <b-button
              block
              @click="Edit2(0)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Inquiry") }}</span>
            </b-button>
          </b-col>
          <b-col
            xl="2"
            lg="2"
            md="6"
            sm="6"
            cols="12"
            class="mb-1 mb-lg-0"
            v-if="rights.add"
          >
            <b-button
              block
              @click="Edit2(-1)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
            >
              <feather-icon icon="UserPlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Visitor") }}</span>
            </b-button>
          </b-col>
          <b-col
            xl="2"
            lg="2"
            md="4"
            sm="12"
            cols="12"
            class="mb-1 mb-lg-0"
            v-if="false"
          >
            <b-button
              v-if="!byFilter"
              block
              @click="FilterInit()"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              :disabled="filterLoading"
            >
              <b-spinner v-if="filterLoading" small />
              <div v-else>
                <feather-icon icon="FilterIcon" class="mr-50" />
                <span class="align-middle">{{ $t("Filter") }}</span>
              </div>
            </b-button>
            <b-button
              v-else
              block
              @click="LoadData(1)"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
            >
              <feather-icon icon="XIcon" class="mr-50" />
              <span class="align-middle">{{ $t("Clear") }}</span>
            </b-button>
          </b-col>
          <!-- <b-col xl="2" lg="3" md="4" sm="12" cols="12">
            <b-form-group
              label="Date"
              invalid-feedback="Date is required"
              ref="fil_date"
            >
              <flat-pickr
                ref="fil_date"
                v-model="searchDate"
                :config="config"
                class="form-control"
                placeholder="Filter by Date"
                @on-change="filterInquiry()"
              />
            </b-form-group>
          </b-col> -->
          <b-col
            xl="5"
            lg="5"
            md="6"
            sm="12"
            cols="12"
            class="d-flex align-items-start"
          >
            <b-button
              v-if="!byFilter"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.top
              :title="$t('Filter')"
              class="btn-icon mr-1"
              :disabled="filterLoading"
              @click="FilterInit()"
            >
              <b-spinner v-if="filterLoading" small />
              <feather-icon v-else icon="FilterIcon" />
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.top
              :title="$t('Clear Filter')"
              class="btn-icon mr-1"
              @click="LoadData(1)"
            >
              <feather-icon icon="XIcon" />
            </b-button>
            <b-form-group class="w-100" style="">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>

                <b-form-input
                  v-model="searchQuery"
                  :placeholder="$t('Search') + '...'"
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
            xl="3"
            lg="3"
            md="6"
            sm="12"
            cols="12"
            class="d-flex align-items-center justify-content-between pl-lg-0"
          >
            <b-form-group
              label=""
              style="width: 90%"
              :invalid-feedback="$t('Date is required')"
              class="pr-50"
            >
              <v-select
                v-model="currentType"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="typeOptions"
                :reduce="(opt) => opt.value"
                label="text"
                @input="LoadData(1)"
                :clearable="false"
                :placeholder="$t('Select status')"
              />
            </b-form-group>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.top
              :title="$t('Refresh')"
              class="btn-icon mb-1"
              :disabled="refreshing"
              @click="refreshData()"
            >
              <b-spinner v-if="refreshing" small />
              <feather-icon v-else icon="RefreshCcwIcon" class="" />
            </b-button>
            <b-button
              v-if="!rights.disableExport"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.top
              :title="$t('Export')"
              class="btn-icon mb-1 ml-50"
              :disabled="exporting"
              @click="exportData()"
            >
              <b-spinner v-if="exporting" small />
              <feather-icon v-else icon="UploadIcon" class="" />
            </b-button>
            <b-button
              @click="openQr()"
              variant="outline-secondary"
              class="btn-icon p-0 mb-1 ml-50"
              v-b-tooltip.hover.top
              :title="$t('Generate QR Code')"
            >
              <img src="@/assets/images/icons/qr-code.png" width="34" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="d-flex align-items-center"
            :class="[
              reportDomain == 'myskoolhpgs' && $store.state.userData.cId == 1
                ? 'justify-content-end col-md-8'
                : 'justify-content-center col-md-12',
            ]"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="filters.length"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
          <b-col
            md="4"
            v-if="
              reportDomain == 'myskoolhpgs' && $store.state.userData.cId == 1
            "
          >
            <v-select
              v-model="selectedCampus"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ id: 0, branch: 'All' }, ...campuses]"
              :clearable="false"
              :reduce="(val) => val.id"
              label="branch"
              :placeholder="$t('Select campus')"
              @input="filterData()"
            />
          </b-col>
        </b-row>
        <b-table
          class="mt-1"
          ref="selectableTable"
          :items="filters"
          :fields="fields"
          :busy="dataLoading"
          :current-page="currentPage"
          :per-page="perPage"
          show-empty
          responsive
          hover
          small
          :selectable="rights.edit"
          select-mode="single"
          @row-selected="Edit2($event[0])"
        >
          <template #empty="scope">
            <h3 class="mt-1 mb-1 text-center">
              {{ $t("No records found") }}
            </h3>
          </template>
          <template #table-busy>
            <div
              class="d-flex justify-content-center mb-3"
              style="margin-top: 50px"
            >
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                :label="$t('Spinning')"
              ></b-spinner>
            </div>
          </template>

          <template #head()="scope">
            <div :class="scope.label == 'actions' && 'text-center'">
              {{ $t(scope.label) }}
            </div>
          </template>

          <template #cell(index)="data">
            <!-- {{ data.index + 1 }} -->
            {{ filters.indexOf(data.item) + 1 }}
          </template>

          <template #cell(name)="data">
            <div style="">
              <b-badge variant="light-primary" style="margin-bottom: 4px">
                {{ data.item.inquiry.name }}
              </b-badge>
              <br />
              <b-badge variant="light-primary" style="margin-bottom: 4px">
                F/N : {{ data.item.inquiry.father_name }}
              </b-badge>
              <br />
              <b-badge variant="light-primary" style="margin-bottom: 4px">
                {{ $t("ID") }}: {{ data.item.inquiry.id }}
              </b-badge>
              <br />
              <b-badge variant="light-primary" style="margin-bottom: 4px">
                {{ data.item.inquiry.contact }}
              </b-badge>
              <br />
              <b-badge
                variant="light-primary"
                style="margin-bottom: 4px"
                v-if="data.item.inquiry.email"
              >
                {{ data.item.inquiry.email }}
              </b-badge>
            </div>
          </template>

          <template #cell(campus)="data">
            <b-badge variant="light-primary">
              {{ getCampus(data.item.inquiry.campusID) }}
            </b-badge>
          </template>

          <template #cell(class)="data">
            <b-badge variant="light-primary">
              {{ getClass(data.item.inquiry.cls) }}
            </b-badge>
          </template>

          <template #cell(inquiry.nextFollowup)="data">
            <b-badge
              variant="light-primary"
              v-if="data.item.inquiry.nextFollowup"
            >
              {{
                new Date(data.value).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
          </template>
          <template #cell(inquiry.inquiryStatus)="data">
            <b-badge
              :variant="
                !data.value || data.value == 'pending'
                  ? 'light-danger'
                  : 'light-success'
              "
            >
              {{ !data.value ? "pending" : data.value }}
            </b-badge>
          </template>
          <template #cell(reference)="data">
            <b-badge variant="light-primary">
              {{ getReference(data.item.inquiry.referenceID) }}
            </b-badge>
          </template>
          <template #cell(inquiry.date)="data">
            <b-badge variant="light-primary">
              {{
                new Date(data.value).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div class="d-flex justify-content-center">
              <b-button
                v-if="rights.edit"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                v-b-tooltip.hover.left
                :title="$t('Edit')"
                class="btn-icon mr-1"
                @click="Edit2(data.item)"
              >
                <!-- :to="{
                  name: 'manage-inquiry-new',
                  params: {
                    id: data.item,
                  },
                }" -->
                <feather-icon icon="EditIcon" class="" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                v-b-tooltip.hover.left
                :title="$t('Print')"
                class="btn-icon mr-1"
                @click="printInquiry(data.item)"
              >
                <feather-icon icon="PrinterIcon" />
              </b-button>

              <template v-if="rights.edit">
                <template
                  v-if="
                    data.item.inquiry.inquiryType == 'visitor' &&
                    checkOutObj &&
                    checkOutObj.valueBool
                  "
                >
                  <b-button
                    v-if="
                      data.item.inquiry.visitingTime &&
                      !data.item.inquiry.checkoutTime
                    "
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    v-b-tooltip.hover.left
                    :title="$t('Visitor check out')"
                    class="btn-icon mr-1"
                    @click="openOut(data.item.inquiry)"
                  >
                    <feather-icon icon="CheckCircleIcon" class="" />
                  </b-button>
                </template>

                <b-button
                  v-else
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  v-b-tooltip.hover.left
                  :title="$t('Move to Registration')"
                  class="btn-icon mr-1"
                  @click="move(data.item)"
                >
                  <feather-icon icon="CheckCircleIcon" class="" />
                </b-button>
              </template>

              <b-button
                v-if="rights.delete"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-danger"
                v-b-tooltip.hover.right
                :title="$t('Delete')"
                class="btn-icon"
                @click="Delete(data.item.inquiry.id)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
  BImg,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  BInputGroupPrepend,
  BInputGroup,
  VBTooltip,
  VBToggle,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { mapActions, mapGetters } from "vuex";

import QrcodeVue from "qrcode.vue";
import { useClipboard } from "@vueuse/core";
const { copy } = useClipboard();

import * as XLSX from "xlsx";
import { buildHasanIslamicPublicInquiryUrl } from "@/utils/inquiryPublicLinks";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BImg,
    BFormCheckbox,
    BFormGroup,
    BForm,
    BSpinner,
    BSidebar,
    BInputGroupPrepend,
    BInputGroup,
    vSelect,
    flatPickr,
    QrcodeVue,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
          disableImport: ch.disableImport,
          disableExport: ch.disableExport,
          optional: ch.optional || ch.optimal,
        };
      });
    });
    // console.log(right);
    this.$store.commit("setRights", right);

    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData();
      this.LoadClasses();
      this.LoadReference();
      this.LoadSettingsAll();
      this.intervalID = setInterval(this.refreshData, 31000);
      if (
        this.reportDomain == "myskoolhpgs" &&
        this.$store.state.userData.cId == 1
      ) {
        this.fields.splice(2, 0, { label: "campus", key: "campus" });
      }
    }
  },
  beforeDestroy() {
    if (this.intervalID) clearInterval(this.intervalID);
  },
  computed: {
    filters: function () {
      const keyword = this.searchQuery.toLowerCase();
      return this.items.filter((pro) => {
        return (
          (pro.inquiry.name && pro.inquiry.name.toLowerCase().match(keyword)) ||
          (pro.inquiry.purpose &&
            pro.inquiry.purpose.toLowerCase().match(keyword)) ||
          (pro.inquiry.tag && pro.inquiry.tag.toLowerCase().match(keyword))
        );
      });
    },

    hostname() {
      return window.location.hostname;
    },

    /** crestview + myskool: QR link follows Inquiry / Visitors filter */
    isQrTypeDomain() {
      return ["myskoolcrestviewacademy", "myskool"].includes(this.reportDomain);
    },
    qrInquiryType() {
      return this.currentType === false ? "visitor" : "inquiry";
    },
    qrModalTitle() {
      if (!this.isQrTypeDomain) {
        return this.$t("Inquiry Form QR Code");
      }
      return this.qrInquiryType === "visitor"
        ? this.$t("Visitor Form QR Code")
        : this.$t("Inquiry Form QR Code");
    },
  },
  data() {
    return {
      intervalID: null,
      refreshing: false,
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      selectedCampus: 0,
      campuses: this.$store.state.branches,
      rights: {},
      referenceData: [],
      classes: [],
      filterTags: [],
      filterClasses: [],
      filter: {
        clsIDs: [],
        tags: [],
        campusID: this.$store.state.userData.cId,
        db: this.$store.state.userData.db,
        dateFrom: null,
        dateTill: null,
        followDateFrom: null,
        followDateTill: null,
      },
      filterDate: null,
      filterFollowDate: null,
      byFilter: false,
      filterLoading: false,
      dataLoading: false,
      searchQuery: "",
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      fields: [
        { label: "S.No", key: "index" },
        { label: "name", key: "name" },
        // { label: "Name", key: "inquiry.name" },
        // { label: "Father Name", key: "inquiry.father_name" },
        { label: "Class", key: "class" },
        // { label: "Contact", key: "inquiry.contact" },
        // { label: "Email", key: "inquiry.email" },
        { label: "Purpose", key: "inquiry.purpose" },
        { label: "Tag", key: "inquiry.tag" },
        { label: "Reference", key: "reference" },
        { label: "Date", key: "inquiry.date" },
        { label: "Next Followup", key: "inquiry.nextFollowup" },
        { label: "Status", key: "inquiry.inquiryStatus" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      allItems: [],
      typeOptions: [
        { text: "Inquiry", value: true },
        { text: "Visitors", value: false },
        // { text: "Registered", value: "registered" },
      ],
      currentType: true,
      searchDate: "",
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      config3: {
        noCalendar: true,
        enableTime: true,
        altFormat: "h:i K",
        altInput: true,
        dateFormat: "H:i:S",
        defaultHour: 8,
      },
      exporting: false,
      qrValue: "",
      checkOutObj: null,
      updating: false,
      outObj: {},
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    normalizeInquiryType(value) {
      const raw = String(value || "inquiry")
        .toLowerCase()
        .trim();
      if (raw === "visitor" || raw === "visitors") return "visitor";
      return "inquiry";
    },

    normalizeFilterTags(tags) {
      const list = Array.isArray(tags) ? [...tags] : [];
      if (this.reportDomain !== "myskoolprofectus") {
        return list;
      }
      const normalized = list.map((tag) =>
        String(tag).trim().toLowerCase() === "online" ? "Online Inquiry" : tag
      );
      return [...new Set(normalized)];
    },

    openQr() {
      const origin = window.location.origin;
      if (
        ["inquiry.whssjuniors.edu.pk", "inquiry.wahajhussains.edu.pk"].includes(
          this.hostname
        )
      ) {
        this.qrValue = `${origin}/school-inquiry`;
      } else if (this.reportDomain == "myskoolelixir") {
        this.qrValue = `${origin}/inquiry-elixir`;
      } else if (this.reportDomain == "myskoolhpgs") {
        this.qrValue = `${origin}/inquiry-hpgs?cID=${this.$store.state.userData.cId}`;
      } else if (["myskoolwhss", "myskoolwhales"].includes(this.reportDomain)) {
        this.qrValue = `${origin}/school-inquiry?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`;
      } else if (
        ["myskoolprofectus", "myskool", "myskoolpfs"].includes(
          this.reportDomain
        )
      ) {
        this.qrValue = `${origin}/school-inquiry?db=${this.$store.state.userData.db}`;
      } else if (this.reportDomain === "myskoolhasanislamic") {
        this.qrValue = buildHasanIslamicPublicInquiryUrl(origin);
      } else if (
        ["myskoolveritas", "myskoolkentschool"].includes(this.reportDomain)
      ) {
        this.qrValue = `${origin}/student-registration?db=${this.$store.state.userData.db}&cId=${this.$store.state.userData.cId}`;
      } else {
        this.qrValue = `${origin}/school-inquiry?db=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}`;
      }
      if (this.isQrTypeDomain) {
        const sep = this.qrValue.includes("?") ? "&" : "?";
        this.qrValue = `${this.qrValue}${sep}type=${this.normalizeInquiryType(
          this.qrInquiryType
        )}`;
      }
      this.$bvModal.show("modal-qr");
    },
    copyQr() {
      copy(this.qrValue);
      this.$bvToast.toast(this.$t("Link Copied."), {
        title: this.$t("Copied!"),
        variant: "success",
        toaster: "b-toaster-top-center",
        solid: true,
      });
    },
    saveQr() {
      const canvas = document.querySelector("#modal-qr canvas");
      let image = canvas.toDataURL();
      let dLink = document.createElement("a");
      dLink.download = this.isQrTypeDomain
        ? `${this.qrInquiryType}-form.png`
        : "inquiry.png";
      dLink.href = image;
      dLink.click();
    },

    filterData() {
      if (this.selectedCampus == 0) {
        this.items = this.allItems;
      } else {
        this.items = this.allItems.filter(
          (el) => el.inquiry.campusID == this.selectedCampus
        );
      }
    },

    setDate(sd, dateStr) {
      // console.log(dateStr);
      if (dateStr) {
        let dt = dateStr.split(" to ");
        if (dt.length == 1) {
          this.filter.dateFrom = dt[0];
          this.filter.dateTill = dt[0];
        } else {
          this.filter.dateFrom = dt[0];
          this.filter.dateTill = dt[1];
        }
      } else {
        this.filterDate = null;
        this.filter.dateFrom = null;
        this.filter.dateTill = null;
      }
    },
    setFDate(sd, dateStr) {
      // console.log(dateStr);
      if (dateStr) {
        let dt = dateStr.split(" to ");
        if (dt.length == 1) {
          this.filter.followDateFrom = dt[0];
          this.filter.followDateTill = dt[0];
        } else {
          this.filter.followDateFrom = dt[0];
          this.filter.followDateTill = dt[1];
        }
      } else {
        this.filterDate = null;
        this.filter.followDateFrom = null;
        this.filter.followDateTill = null;
      }
    },

    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "";
    },
    getClass(id) {
      let obj = this.classes.find((el) => el.id == id);
      return obj ? obj.name : "";
    },
    getReference(id) {
      if (id) {
        let obj = this.referenceData.find((el) => el.id == id);
        return obj ? obj.name : "";
      }
      return "";
    },

    exportData() {
      this.exporting = true;

      let newData = this.items.map((item) => ({
        name: item.inquiry.name,
        father: item.inquiry.father_name,
        contact: item.inquiry.contact,
        email: item.inquiry.email,
        purpose: item.inquiry.purpose,
        tag: item.inquiry.tag,
        class: this.getClass(item.inquiry.cls),
        date: item.inquiry.date
          ? item.inquiry.date.split("T")[0]
          : item.inquiry.date,
        nextFollowup: item.inquiry.nextFollowup
          ? item.inquiry.nextFollowup.split("T")[0]
          : item.inquiry.nextFollowup,
        // attachments: item.attachments,
        "last school": item.inquiry.lastSchool,
        "residential area": item.inquiry.residentialArea,
      }));

      if (this.reportDomain === "myskoolhasanislamic") {
        newData = this.items.map((item) => ({
          name: item.inquiry.name,
          father: item.inquiry.father_name,
          contact: item.inquiry.contact,
          email: item.inquiry.email,
          purpose: item.inquiry.purpose,
          tag: item.inquiry.tag,
          class: this.getClass(item.inquiry.cls),
          section: item.inquiry.sec || "",
          date: item.inquiry.date
            ? item.inquiry.date.split("T")[0]
            : item.inquiry.date,
          nextFollowup: item.inquiry.nextFollowup
            ? item.inquiry.nextFollowup.split("T")[0]
            : item.inquiry.nextFollowup,
          "last institution": item.inquiry.lastSchool,
          "residential area": item.inquiry.residentialArea,
        }));
      } else if (["myskoolwhss", "myskoolwhales"].includes(this.reportDomain)) {
        newData = this.items.map((item) => ({
          name: item.inquiry.name,
          father: item.inquiry.father_name,
          contact: item.inquiry.contact,
          email: item.inquiry.email,
          purpose: item.inquiry.purpose,
          tag: item.inquiry.tag,
          class: this.getClass(item.inquiry.cls),
          date: item.inquiry.date
            ? item.inquiry.date.split("T")[0]
            : item.inquiry.date,
          "studying since": item.inquiry.studyingSince,
          status: item.inquiry.inquiryStatus,
          nextFollowup: item.inquiry.nextFollowup
            ? item.inquiry.nextFollowup.split("T")[0]
            : item.inquiry.nextFollowup,
          // attachments: item.attachments,
        }));
      }

      const worksheet = XLSX.utils.json_to_sheet(newData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      XLSX.writeFile(workbook, "inquiry.xlsx");

      this.exporting = false;
    },

    move(obj) {
      this.$router.push({
        name: "student-public",
        params: {
          inqObj: obj.inquiry.id,
        },
      });
    },
    printInquiry(item) {
      const referenceName =
        this.getReference(item.inquiry.referenceID) ||
        item.inquiry.referenceOther ||
        "";

      sessionStorage.setItem(
        "inquiryPrintPayload",
        JSON.stringify({
          inquiry: item.inquiry,
          className: this.getClass(item.inquiry.cls),
          referenceName,
          campusName: this.getCampus(item.inquiry.campusID),
          reportDomain: this.reportDomain,
        })
      );

      const route = this.$router.resolve({
        name: "inquiry-detail-print",
      });
      window.open(route.href, "_blank");
    },
    Edit2(id) {
      if (![0, -1].includes(id)) {
        this.changestatus(id);
      }
      this.$router.push({
        name: "manage-inquiry-new",
        params: {
          id,
        },
      });
    },
    async changestatus(item) {
      let inq = { ...item.inquiry };
      if (!inq.inquiryStatus || inq.inquiryStatus == "pending") {
        inq.inquiryStatus = "in progress";
        var status = await this.put({
          url:
            this.$store.state.domain +
            "studentinquiries/" +
            inq.id +
            "?db=" +
            this.$store.state.userData.db,
          body: inq,
          importing: true,
          context: this,
          token: this.$store.state.userData.token,
        });
      }
    },
    openOut(obj) {
      this.$bvModal.show("modal-out");
      this.outObj = { ...obj };
    },
    async updateOut() {
      this.updating = true;
      var status = await this.put({
        url:
          this.$store.state.domain +
          "studentinquiries/" +
          this.outObj.id +
          "?db=" +
          this.$store.state.userData.db,
        body: this.outObj,
        message: "Visitor check out updated successfully.",
        context: this,
        token: this.$store.state.userData.token,
      });
      this.updating = false;
      if (status) {
        this.refreshData();
        this.$bvModal.hide("modal-out");
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });

      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "studentinquiries/Remove?db=" +
            this.$store.state.userData.db +
            "&id=" +
            id,
          message: "Inquiry deleted successfully.",
          context: this,
          body: null,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },

    async refreshData() {
      this.refreshing = true;
      if (this.byFilter) {
        var status = await this.post({
          url: this.$store.state.domain + "studentinquiries/FilterNew",
          body: this.filter,
          subjects: true,
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.items = status;
          this.allItems = status;
        }
      } else {
        let myitem = await this.post({
          url:
            this.$store.state.domain +
            "studentinquiries/FilterByType?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId +
            "&inquiry=" +
            this.currentType,
          token: this.$store.state.userData.token,
          body: null,
          subjects: true,
          context: this,
        });
        if (myitem) {
          this.items = myitem;
          this.allItems = myitem;
        }
      }
      this.refreshing = false;
    },

    async LoadData(pg) {
      let page = pg ? pg : this.currentPage;
      this.byFilter = false;
      this.dataLoading = true;
      this.items = [];
      // let myitem = await this.get({
      //   url:
      //     this.$store.state.domain +
      //     "studentinquiries?db=" +
      //     this.$store.state.userData.db +
      //     "&cId=" +
      //     this.$store.state.userData.cId,
      //   token: this.$store.state.userData.token,
      // });
      let myitem = await this.post({
        url:
          this.$store.state.domain +
          "studentinquiries/FilterByType?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&inquiry=" +
          this.currentType,
        token: this.$store.state.userData.token,
        body: null,
        subjects: true,
        context: this,
      });
      // console.log(myitem);
      if (myitem) {
        this.items = myitem;
        this.allItems = myitem;
      }
      this.dataLoading = false;
      setTimeout(() => {
        this.currentPage = page;
      }, 100);
    },
    async LoadFilter() {
      this.byFilter = true;
      this.dataLoading = true;
      var status = await this.post({
        // "studentinquiries/Filter",
        url: this.$store.state.domain + "studentinquiries/FilterNew",
        body: this.filter,
        subjects: true,
        context: this,
        token: this.$store.state.userData.token,
      });

      this.$bvModal.hide("modal-login");
      // console.log(status);
      if (status) {
        this.items = status;
        this.allItems = status;
      }
      this.dataLoading = false;
      this.currentPage = 1;
    },
    async FilterInit() {
      this.filterLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "StudentInquiries/FilterInit?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      // console.log(res);
      this.filterTags = this.normalizeFilterTags(res.tags);
      this.filterClasses = res.cls;
      this.filterLoading = false;
      this.$bvModal.show("modal-login");
    },
    async LoadClasses() {
      let obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };

      if (this.reportDomain == "myskoolhpgs") {
        obj = {
          url:
            this.$store.state.domain +
            "myclasses/LoadClassesAll?db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId +
            "&dID=0",
          token: this.$store.state.userData.token,
        };
      }

      let myItems = await this.get(obj);
      this.classes = myItems.map((el) => el.cls);
      // this.classes.unshift({ name: "None", id: 0 });
      // console.log(this.classes);
    },
    async LoadReference() {
      let obj = {
        url:
          this.$store.state.domain +
          "InquiryReferrence?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.referenceData = await this.get(obj);
      // console.log(this.referenceData);
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: ["visitor_checkout"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.checkOutObj = res.find((el) => el.key == "visitor_checkout");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style scoped>
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
</style>
